export enum AvailableStorage {
    SESSION = "sessionStorage",
    LOCAL = "localStorage",
}
